module.exports = __webpack_public_path__ + "vue_assets/img/img_assetpack_orcish.34f9ad3b.jpg";